import React from 'react';
import Modal from '../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../Services/TreatmentContext';
import { FormValues } from '../../MagicForm/Interfaces/FormValues';
import EPrescriptionMedicamentsHVLPForm, {
	EPrescriptionHVLPMedicament,
} from './EPrescriptionMedicamentsHVLPForm';
import EPrescriptionMedicamentsIPLPForm, {
	EPrescriptionIPLPMedicament,
} from './EPrescriptionMedicamentsIPLPForm';
import { EPrescriptionMedicament } from './EPrescriptionMedicamentsWrapper';
import { Size } from '../../../Enums/Size.enum';

export enum MedicamentsForm {
	HVLP = 0,
	IPLP = 1,
}

interface EPrescriptionMedicamentsModalProps {
	isOpen: boolean;
	form: MedicamentsForm;
	modalTitle: string;
	onClose: () => void;
	onSubmit: (values: EPrescriptionMedicament) => void;
	size: Size;
	defaultValues?: EPrescriptionMedicament;
	patientId: string;
	isSelfPayer: boolean;
}

const EPrescriptionMedicamentsModal: React.FC<
	EPrescriptionMedicamentsModalProps
> = ({
	isOpen,
	form,
	modalTitle,
	onClose,
	onSubmit,
	size,
	defaultValues,
	patientId,
	isSelfPayer,
}) => {
	const { isCase } = useTreatmentContext();

	const handleSubmit = (
		values: EPrescriptionHVLPMedicament | EPrescriptionIPLPMedicament,
	) => {
		onSubmit(values);
		onClose();
	};

	return (
		<div>
			<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={size}>
				<Modal.Header title={modalTitle} />
				<Modal.Content>
					{form === MedicamentsForm.HVLP ? (
						<EPrescriptionMedicamentsHVLPForm
							onSubmit={handleSubmit}
							defaultValues={defaultValues}
							patientId={patientId}
							isSelfPayer={isSelfPayer}></EPrescriptionMedicamentsHVLPForm>
					) : (
						<EPrescriptionMedicamentsIPLPForm
							onSubmit={handleSubmit}
							defaultValues={defaultValues}
							patientId={patientId}
							isSelfPayer={isSelfPayer}></EPrescriptionMedicamentsIPLPForm>
					)}
				</Modal.Content>
			</Modal>
		</div>
	);
};

export default EPrescriptionMedicamentsModal;
